<template lang="html">
  <div class="navigation-bar max-1200" ref="component">
    <div class="navigation-bar-conainer flex-box vertically-centered" v-if="noSlot">
      <div v-if="preupload" class="row-with-icon">

      </div>
      <div v-if="!preupload" class="row-with-icon flex-box gray" @click="() => this.$emit('back-to-listing')">
        <span class="si-icon-bold si-arrow_left si-icon-text-4x hgap-4-right"></span> 
        <span class="bold desktop-only">Back to Your Listings</span>
        <span class="bold mobile-only">Back</span>
      </div>
      <div class="action-buttons">
        <SymbiumButton
          text="Save Draft"
          :onClick="() => $emit('save-draft')"
          :isPrimary="true"
          :isSmall="true"
          kclass="desktop-only"
        />
        <SymbiumButton
          text="Save"
          :onClick="() => $emit('save-draft')"
          :isPrimary="true"
          :isSmall="true"
          kclass="mobile-only"
        />
        <SymbiumButton
          text="Preview"
          :onClick="() => $emit('open-preview')"
          :isPrimary="true"
          :isSmall="true"
        />
        <SymbiumButton
          v-if="!preupload"
          :text="publishText"
          :onClick="() => $emit('publish-draft')"
          :isSmall="true"
          :isDisabled="isSuspendedVendor"
          kclass="desktop-only"
        />
        <SymbiumButton
          v-if="!preupload"
          text="Publish"
          :onClick="() => $emit('publish-draft')"
          :isSmall="true"
          :isDisabled="isSuspendedVendor"
          kclass="mobile-only"
        />
      </div>
    </div>
    <div class="navigation-bar-conainer flex-box" v-if="!noSlot">
      <slot />
    </div>
  </div>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton},
  props: ['preupload', 'needReplace', 'isSuspendedVendor'],
  methods: {
    handleScroll() {
      if((window.innerWidth > 768 && window.scrollY >= 80) || (window.innerWidth <= 768 && window.scrollY >= 64)) {
        this.$refs.component.style.position = 'fixed';
        this.$refs.component.style.top = '0';
        this.$refs.component.style.left = '50%';
        this.$refs.component.style.transform = 'translateX(-50%)';
        this.$refs.component.style.background = 'white';
        this.$emit('become-fixed')
      } else {
        this.$refs.component.style.position = 'static';
        this.$refs.component.style.background = 'none';
        this.$refs.component.style.transform = 'unset';
        this.$emit('become-unfixed')
      }
    }
  },
  computed: {
    noSlot() {
      return !(this.$slots.default && this.$slots.default[0].tag)
    },
    publishText() {
      return this.needReplace ? 'Replace and Publish' :  'Save & Publish'
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="scss" scoped>
.navigation-bar {
  border-bottom: 1px solid #dddddd;
  background: none;
  width: 100%;
  z-index: 1000;
  padding: 16px 24px;

  .navigation-bar-conainer {
    width: 100%;
    justify-content: space-between;
  }

  .row-with-icon {
    padding: 0;
    line-height: 32px;

    img {
      margin-right: 24px;
    }
  }

  .action-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    row-gap: 8px;
  }

  .btn-base {
    float: none;
    margin-left: 24px;
  }

  @media screen and (max-width: 768px) {
    min-width: 100%;

    .btn-base {
      margin-left: 8px;
    }

    .navigation-bar-conainer {
      max-width: 100%
    }
  }
}
</style>
